async function fetchCartInfomation() {
	try {
		const response = await fetch(window.Shopify.routes.root + "cart.js");
		const data = await response.json();
		return data;
	} catch (error) {
		console.error(error);
	}
}